import React from 'react';
import profilePic from '../../profile-pic.jpeg';
import projectPhoto from '../../photos/project-img.jpg';
import  '../../styles/portfolio.css';

function AboutMeHeader(props) {
    //let abc = Object.values(props.description);
   /* const printDescription = abc.map(subDesc =>{
        return(
            <p>{subDesc}</p>
        )
    });*/

    //const {description} = props;

    let imgComponent;

    switch(props.imageType) {
      case 'profile':
        imgComponent = <img src ={profilePic} alt='unable to load img' className='profile-img'/>
         break
      case 'project':
        imgComponent = <img src ={projectPhoto} alt='unable to load project ' className='profile-img'/>
        break
      default:
        imgComponent = <img src ={profilePic} alt='unable to load default' className='profile-img'/>
    }

    return (
        <div className='about-me-header'>
            {imgComponent}
            <div className='description-left'>
                <h4 style={{textAlign:'left'}}>{props.title}</h4>
                <div className='sub-description-left'>
                    {props.isItAHeader ? <p>{props.desc1}</p> : <p><a href='https://www.amazon.com/Prakash-Daily-spend/dp/B087XSKM7H/ref=sr_1_6?dchild=1&qid=1619964226&refinements=p_4%3APrakash&s=mobile-apps&search-type=ss&sr=1-6' className='project-links'>{props.desc1}</a></p>}
                    {props.isItAHeader ? <p>{props.desc2}</p>:<p></p>}
                    {props.isItAHeader ? <p>{props.desc3}</p>:<p><a href='https://www.amazon.com/Prakash-Help-me/dp/B089136D3J/ref=sr_1_5?dchild=1&qid=1619964226&refinements=p_4%3APrakash&s=mobile-apps&search-type=ss&sr=1-5' className='project-links'>{props.desc3}</a></p>}
                    <p><a href='https://www.amazon.com/Prakash-Lend-and-Borrow/dp/B08BK2YWQP/ref=sr_1_7?dchild=1&qid=1619964226&refinements=p_4%3APrakash&s=mobile-apps&search-type=ss&sr=1-7' className='project-links'>{props.desc4}</a></p>
                    <p><a href='https://www.amazon.com/Prakash-Women-safe/dp/B088TWG51M/ref=sr_1_4?dchild=1&qid=1619964226&refinements=p_4%3APrakash&s=mobile-apps&search-type=ss&sr=1-4' className='project-links'>{props.desc5}</a></p>
                    {!props.isItAHeader && <p><a href='https://prakash-tiwari.netlify.app/' className='project-links' style={{color:'yellow'}}>This Website itself !!</a></p>}
                    {!props.isItAHeader && <p><a href='https://books-exchange.netlify.app/' className='project-links' style={{color:'lightBlue'}}>Books Exchange Application</a></p>}
                    {!props.isItAHeader && <p><a href='https://personality-compatibility.netlify.app/' className='project-links' style={{color:'orange'}}>A Survey Application For Research - Used by 175+ nursing students</a></p>}
                    {props.isItAHeader && <p style={{'width':'330px','background':'darkgoldenrod','textAlign':'left','marginTop':'8px'}}>Don't even touch your code once it starts working</p>}
                </div>
            </div>
        </div>
    );
}

export default AboutMeHeader;